import React from 'react'
import PropTypes from 'prop-types'

import BuyTry from '@/components/blocks/BuyTry'
import { Rows, Section, Column } from '@/components/layout'
import { Text } from '@/components/common'

import BuyNowCta from '../BuyNowCta'

import styles from './ProductHeader.module.scss'

const ProductHeader = ({ title, subtitle, smallPrint, cta, canTry = true }) => (
  <Section bgForeground className={styles.productHeader}>
    <Column alignCenter maxWidth={800} textCenter>
      <Rows gap={8}>
        <Text.H1 brandSecondary size="large">{title}</Text.H1>
        <Text.H2 color="tint-brand-secondary" onTint>{subtitle}</Text.H2>
      </Rows>
      <Rows alignCenter className={styles.buttonWrap}>
        {
          cta ? (
            <BuyNowCta noOutline sku={cta.sku} style={{ border: '0' }} />
          ) : (
            <BuyTry canTry={canTry} noOutline />
          )
        }
      </Rows>
      <Text.P onTint size="small">{smallPrint}</Text.P>
    </Column>
  </Section>
)

ProductHeader.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  smallPrint: PropTypes.node,
  canTry: PropTypes.bool,
  cta: PropTypes.objectOf(PropTypes.string),
}

export default ProductHeader
